exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".excel[data-v-383ee94b]{color:#fff;background:#2acc6b;border-radius:4px!important;padding:10px 28.86px;border:none;transition:.2s}.excel[data-v-383ee94b],.excel span[data-v-383ee94b]{display:flex;align-items:center}.excel[data-v-383ee94b]:active,.excel[data-v-383ee94b]:hover{background:#08a747}.excel i[data-v-383ee94b]{font-size:20px;margin-right:8px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-383ee94b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/pages/components/buttons/btnExcel.vue
// module id = 834
// module chunks = 0